module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "editor"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless"
  }, [_c('div', {
    staticClass: "column is-2 func-div"
  }, [_c('div', {
    staticClass: "has-text-centered has-text-white func-button",
    on: {
      "click": function($event) {
        return _vm.save2()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "func-button-text"
  }, [_vm._v("保存")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toSaveFlag),
      expression: "toSaveFlag"
    }],
    staticClass: "to-save"
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered has-text-white func-button",
    on: {
      "click": function($event) {
        return _vm.preview()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', {
    staticClass: "func-button-text"
  }, [_vm._v("预览")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered has-text-white func-button",
    class: {
      'func-selected': _vm.module == 0
    },
    on: {
      "click": function($event) {
        return _vm.changeModule(0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "func-button-text"
  }, [_vm._v("场景")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered has-text-white func-button",
    class: {
      'func-selected': _vm.module == 1
    },
    on: {
      "click": function($event) {
        return _vm.changeModule(1)
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "func-button-text"
  }, [_vm._v("视角")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered has-text-white func-button",
    class: {
      'func-selected': _vm.module == 2
    },
    on: {
      "click": function($event) {
        return _vm.changeModule(2)
      }
    }
  }, [_vm._m(4), _vm._v(" "), _c('span', {
    staticClass: "func-button-text"
  }, [_vm._v("热点")])]), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered has-text-white func-button",
    class: {
      'func-selected': _vm.module == 3
    },
    on: {
      "click": function($event) {
        return _vm.changeModule(3)
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', {
    staticClass: "func-button-text"
  }, [_vm._v("土地")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-10",
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.module == 0),
      expression: "module == 0"
    }],
    staticClass: "scene-module has-text-white"
  }, [_c('h5', {
    staticClass: "title is-5 has-text-white scene-title"
  }, [_vm._v("场景列表")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _vm._l((_vm.sceneList), function(scene) {
    return _c('div', {
      staticClass: "scene-item",
      class: {
        'scene-item-selected': scene.index == _vm.currentSceneIndex
      }
    }, [_c('div', {
      staticClass: "scene-name",
      on: {
        "click": function($event) {
          return _vm.changeScene(scene)
        }
      }
    }, [_vm._v(_vm._s(scene.name))]), _vm._v(" "), _c('figure', {
      staticClass: "image is-128x128",
      on: {
        "click": function($event) {
          return _vm.changeScene(scene)
        }
      }
    }, [_c('img', {
      staticClass: "thumb",
      attrs: {
        "src": scene.thumburl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "pencil",
      on: {
        "click": function($event) {
          return _vm.showModifyScene(scene)
        }
      }
    }, [_vm._m(6, true)]), _vm._v(" "), _c('div', {
      staticClass: "home",
      on: {
        "click": function($event) {
          return _vm.setWelcome(scene.index)
        }
      }
    }, [_c('a', {
      staticClass: "button is-primary is-inverted is-outlined",
      class: {
        'home-selected': scene.index == _vm.welcomeSceneIndex
      }
    }, [_vm._m(7, true)])]), _vm._v(" "), _c('div', {
      staticClass: "dele",
      on: {
        "click": function($event) {
          return _vm.deleScene(scene)
        }
      }
    }, [_c('a', {
      staticClass: "button is-primary is-inverted is-outlined"
    }, [_c('a-icon', {
      attrs: {
        "type": "delete"
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "toLower"
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('a', {
    staticClass: "button is-small is-info",
    staticStyle: {
      "width": "100%",
      "height": "30px"
    },
    on: {
      "click": _vm.showPlusSceneModal
    }
  }, [_vm._v("添加场景")])])], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.module == 1),
      expression: "module == 1"
    }],
    staticClass: "view-module has-text-white",
    on: {
      "mousemove": function($event) {
        return _vm.moveInitFov()
      },
      "mouseup": function($event) {
        return _vm.stopMoveInitFov()
      }
    }
  }, [_c('div', {
    staticClass: "view-content"
  }, [_c('label', {
    staticClass: "label has-text-white"
  }, [_vm._v("\n            自动旋转\n            "), _c('label', {
    staticClass: "switch is-info view-switch",
    class: {
      'switch-checked': _vm.autoSpinFlag
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoSpinFlag),
      expression: "autoSpinFlag"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.autoSpinFlag) ? _vm._i(_vm.autoSpinFlag, null) > -1 : (_vm.autoSpinFlag)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.autoSpinFlag,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.autoSpinFlag = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.autoSpinFlag = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.autoSpinFlag = $$c
        }
      }, function($event) {
        return _vm.updatedAutoSpin()
      }]
    }
  })])]), _vm._v(" "), _c('label', {
    staticClass: "label has-text-white"
  }, [_vm._v("\n            等待时间（秒）\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autoSpinWaitingTime),
      expression: "autoSpinWaitingTime"
    }],
    staticClass: "input is-small",
    attrs: {
      "disabled": !_vm.autoSpinFlag
    },
    domProps: {
      "value": (_vm.autoSpinWaitingTime)
    },
    on: {
      "change": function($event) {
        return _vm.updatedAutoSpin()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.autoSpinWaitingTime = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "view-content"
  }, [_c('div', {
    staticClass: "view-slider"
  }, [_c('div', {
    staticClass: "view-top-slider",
    on: {
      "mousedown": function($event) {
        return _vm.startMoveInitFov()
      }
    }
  }, [_c('span', {
    style: ({
      left: _vm.initFovLeft + 'px'
    })
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  })])]), _vm._v(" "), _c('vue-slider', {
    attrs: {
      "max": 180,
      "tooltipDir": ['bottom', 'bottom'],
      "dotSize": 12,
      "show": _vm.module == 1
    },
    model: {
      value: (_vm.sliderValue),
      callback: function($$v) {
        _vm.sliderValue = $$v
      },
      expression: "sliderValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "columns has-text-centered"
  }, [_c('div', {
    staticClass: "column is-4"
  }, [_c('span', [_vm._v("最近")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minFov),
      expression: "minFov"
    }],
    staticClass: "input is-small",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.minFov)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minFov = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('span', [_vm._v("初始")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.initFov),
      expression: "initFov"
    }],
    staticClass: "input is-small",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.initFov)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.initFov = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('span', [_vm._v("最远")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxFov),
      expression: "maxFov"
    }],
    staticClass: "input is-small",
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": (_vm.maxFov)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxFov = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.module == 2),
      expression: "module == 2"
    }],
    staticClass: "hotspot-module"
  }, [_c('div', {
    staticClass: "hotspot-add"
  }, [_c('a', {
    staticClass: "button is-small is-info",
    on: {
      "click": function($event) {
        return _vm.showHotspotDetail()
      }
    }
  }, [_vm._v("添加热点")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "hotspot-list"
  }, _vm._l((_vm.hotspotList), function(hotspotItem) {
    return _c('div', {
      staticClass: "hotspot-item",
      class: {
        'hotspot-item-selected': _vm.selectedHotspot.name == hotspotItem.name
      },
      on: {
        "click": function($event) {
          return _vm.showHotspotDetail(hotspotItem)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": hotspotItem.url
      }
    }), _vm._v(" "), _c('div', [_vm._v("场景切换")])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.module == 3),
      expression: "module == 3"
    }],
    staticClass: "land-module"
  }, [_c('Land', {
    ref: "land",
    on: {
      "change-land": _vm.changeLand
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showHotspotDetailFlag),
      expression: "showHotspotDetailFlag"
    }],
    staticClass: "hotspot-detail"
  }, [_c('div', {
    staticClass: "hotspot-detail-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentHotspot.name ? '编辑' : '新增') + "热点")]), _vm._v(" "), _c('a', {
    staticClass: "delete is-large is-pulled-right",
    on: {
      "click": function($event) {
        return _vm.hideHotspotDetail()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "hotspot-detail-content"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label has-text-white"
  }, [_vm._v("图标样式")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline hotspot-detail-style-list"
  }, _vm._l((_vm.hotspotStyleList), function(style) {
    return _c('div', {
      staticClass: "column is-4"
    }, [_c('div', {
      staticClass: "hotspot-detail-style",
      class: {
        'hotspot-detail-style-selected': style.name == _vm.currentHotspot.style
      },
      on: {
        "click": function($event) {
          return _vm.selectHotspotStyle(style.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": style.imgUrl
      }
    })])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label has-text-white"
  }, [_vm._v("热点类型")]), _vm._v(" "), _c('a-select', {
    staticStyle: {
      "width": "89px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.handleHotspotTypeChange
    },
    model: {
      value: (_vm.currentHotspot.hotspottype),
      callback: function($$v) {
        _vm.$set(_vm.currentHotspot, "hotspottype", $$v)
      },
      expression: "currentHotspot.hotspottype"
    }
  }, _vm._l((_vm.hotSpotTypeOptions), function(option) {
    return _c('a-select-option', {
      key: option.id,
      attrs: {
        "value": option.id
      }
    }, [_vm._v(_vm._s(option.text))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label has-text-white"
  }, [_vm._v("切换效果")]), _vm._v(" "), _c('a-select', {
    attrs: {
      "defaultValue": "1",
      "size": "small"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("淡入淡出")])], 1)], 1), _vm._v(" "), (_vm.currentHotspot && _vm.currentHotspot.hotspottype == 1) ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label has-text-white"
  }, [_vm._v("目标场景")]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline hotspot-detail-scene-list"
  }, _vm._l((_vm.sceneListExceptCurrent), function(scene) {
    return _c('div', {
      staticClass: "column is-6 has-text-centered"
    }, [_c('div', {
      staticClass: "hotspot-detail-scene",
      class: {
        'hotspot-detail-scene-selected': scene.name == _vm.currentHotspot.linkedscene
      },
      on: {
        "click": function($event) {
          return _vm.selectHotspotLinkedScene(scene.name)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": scene.thumburl
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scene.name))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field hotspot-detail-button"
  }, [_c('button', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        return _vm.saveCurrentHotspot()
      }
    }
  }, [_vm._v("确定")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentHotspot.name),
      expression: "currentHotspot.name"
    }],
    staticClass: "field hotspot-detail-button"
  }, [_c('button', {
    staticClass: "button is-danger",
    on: {
      "click": function($event) {
        return _vm.deleteCurrentHotspot()
      }
    }
  }, [_vm._v("删除")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.module == 1),
      expression: "module == 1"
    }],
    staticClass: "camera"
  }, [_c('div', {
    staticClass: "camera-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-left-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-top-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-top-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-right-top"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-left-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-bottom-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-bottom-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "camera-right-bottom"
  }), _vm._v(" "), _c('a', {
    staticClass: "button is-info camera-button",
    on: {
      "click": function($event) {
        return _vm.setDefaultView()
      }
    }
  }, [_vm._v("设为初始视角")])]), _vm._v(" "), _c('EditScene', {
    ref: "editScene",
    attrs: {
      "visible": _vm.modalVisible
    },
    on: {
      "cancel": function($event) {
        _vm.modalVisible = false
      },
      "confirm": _vm.editScene
    }
  }), _vm._v(" "), _c('ChooseLand', {
    ref: "choose",
    attrs: {
      "visible": _vm.chooseVisible,
      "areaLevel": _vm.currentLand ? (_vm.currentLand.areaLevel + 1) : 0,
      "areaId": _vm.currentLand ? _vm.currentLand.id : ''
    },
    on: {
      "cancel": function($event) {
        _vm.chooseVisible = false
      },
      "submit": _vm.chooseConfirm,
      "to-land": _vm.toLandByVrId
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-window-restore"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-window-restore"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button is-primary is-inverted is-outlined"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-471b2f62","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/EditorSide.vue
// module id = 1074
// module chunks = 1